import { Menu }             from "@mantine/core";
import { useGetDeviceType } from "_common/hooks/global";
import BackgroundWrapper    from "_components/atoms/backgroundWrapper";
import Icon                 from "_components/atoms/icon";
import Typography           from "_components/atoms/typography";
import BellIcon             from "_components/organisms/notificationTab/components/notificationBellIcon";
import Feed                 from "_components/organisms/notificationTab/components/notificationFeed";
import HeaderTabs           from "_components/organisms/notificationTab/components/notificationHeaderTabs";
import SettingsFeed         from "_components/organisms/notificationTab/components/notificationSettings";
import MenuModal            from "_components/organisms/notificationTab/components/threeDotMenuModal";
import { useRouter }        from "next/router";
import { useTranslation }   from "react-i18next";
import useStyles            from "./styles";
import { useScrollLock }    from "@mantine/hooks";

const Component = ( {
	anchorEl,
	handleClose,
	activeTab,
	changeActiveTab,
	openSettings,
	handleSettingsClose,
	handleSettingsOpen,
	activeUpdateTab,
	changeUpdateTab,
	open,
	handleMarkAllRead,
	marked,
	isNotificationsPage,
	targetButton,
	handleClick,
	notificationCount
} ) => {
	const { classes } = useStyles ( { isNotificationsPage }, { name: "styles" } );
	const { t }       = useTranslation ();

	const deviceType = useGetDeviceType ();

	const isMobile = deviceType === "mobile";

	const Wrapper = ( ) => {
		return (
			<BackgroundWrapper className = { openSettings ? classes.notificationBackgroundWrapperSettings : classes.notificationBackgroundWrapper }>
				{
					openSettings ?
						<SettingsFeed handleSettingsClose = { handleSettingsClose } />
						: (
							<LandingFeed
								activeTab          = { activeTab }
								activeUpdateTab    = { activeUpdateTab }
								anchorEl           = { anchorEl }
								changeActiveTab    = { changeActiveTab }
								changeUpdateTab    = { changeUpdateTab }
								handleMarkAllRead  = { handleMarkAllRead }
								handleSettingsOpen = { handleSettingsOpen }
								marked             = { marked }
							/>
						)
				}

			</BackgroundWrapper>
		);
	};

	if ( isNotificationsPage && isMobile ) {
		return <Wrapper />;
	}

	if ( isNotificationsPage ) {
		return (
			<BackgroundWrapper type = "secondary">
				<Wrapper />
			</BackgroundWrapper>
		);
	}

	useScrollLock ( open );

	return (
		<Menu
			closeOnClickOutside
			closeOnEscape
			// withinPortal
			className  = { classes.mainMenuContainer }
			classNames = { { dropdown: classes.dropdown } }
			onClose    = { () => {
				handleClose ();
				handleSettingsClose ();
			} }
			opened   = { open }
			position = "bottom-end"
			radius   = { "lg" }
		>
			<Menu.Target>
				<div onClick = { handleClick }>
					<BellIcon
						handleClick       = { handleClick }
						notificationCount = { notificationCount }
						open              = { open }
					/>
				</div>
			</Menu.Target>

			<Menu.Dropdown>

				<Wrapper />
			</Menu.Dropdown>

		</Menu>

	);

};

export default Component;

const LandingFeed = props => {
	const {
		handleSettingsOpen,
		activeTab,
		changeActiveTab,
		activeUpdateTab,
		changeUpdateTab,
		handleMarkAllRead,
		marked
	} = props;

	const { classes } = useStyles ( undefined, { name: "styles" } );
	const router      = useRouter ();

	const deviceType = useGetDeviceType ();
	const isMobile   = deviceType === "mobile";

	return (
		<>
			<BackgroundWrapper className = { classes.notificationTopSection }
				type      = "tertiary"
			>
				<div className = { classes.notificationHeaderAndSettings }>
					<div className = { classes.headerTextContainer }>
						{
							isMobile ? (
								<Icon
									className = { classes.backIcon }
									name      = "cross"
									onClick   = { router.back }
								/>
							) : null
						}

						<Typography
							className = { classes.settingsText }
							title     = "Notifications"
							variant   = "h4"
						/>
					</div>

					<MenuModal
						handleMarkAllRead  = { handleMarkAllRead }
						handleSettingsOpen = { handleSettingsOpen }
					/>
				</div>

				<HeaderTabs
					activeTab       = { activeTab }
					activeUpdateTab = { activeUpdateTab }
					changeActiveTab = { changeActiveTab }
					changeUpdateTab = { changeUpdateTab }
				/>
			</BackgroundWrapper>

			<Feed
				activeTab         = { activeTab }
				activeUpdateTab   = { activeUpdateTab }
				handleMarkAllRead = { handleMarkAllRead }
				marked            = { marked }
			/>

		</>
	);
};
